import styled from "styled-components";

export const TitleH1 = styled.span`
  text-align: center;
  font-size: 54px;
  font-weight: 600;
  position: relative;
`;

export const SpanTitleInvoice = styled.strong`
  font-size: 24px;
  font-weight: 300;
`;

export const BiggerTextInvoice = styled.strong`
  font-size: 4rem;
`;

export const SpanTextInvoiceBold = styled.strong`
  font-size: 20px;
  font-weight: 400;
  color: #000;
`;

export const SpanTextTitleBold = styled.span`
  color: #000;
  font-weight: bold;
  font-size: 12px;

  @media print {
    font-size: 8pt;
  }
`;

export const SpanDescription = styled.span`
  font-weight: 400;
  font-size: 20px;

  @media print {
    font-size: 8pt;
  }
`;

export const TitleInvoiceTextValue = styled.span`
  color: #000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  width: 50%;

  @media print {
    font-size: 9pt;
  }
`;

export const DateInvoiceTextValue = styled.span`
  color: #000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  width: 50%;
  display: flex;
  justify-content: flex-end;

  @media print {
    font-size: 8pt;
  }
`;

export const SpanTextTitle = styled.span`
  color: #000;
  font-size: 14px;

  @media print {
    font-size: 9pt;
  }
`;

export const Dividers = styled.hr`
  border-top: 3px dashed #7c7c7c;
  width: 100%;
  height: 1px;

  @media print {
    border-top: 1px solid #000;
  }
`;

export const SpanTitleValue = styled.span`
  color: #000;
  font-size: 13px;
  font-weight: 400;
  margin-top: 1px;
  @media print {
    font-size: 7pt;
  }
`;

export const SpanTextValue = styled.span`
  color: #000;
  font-size: 13px;
  font-weight: 600;
  margin-top: 1px;
  @media print {
    font-size: 7pt;
  }
`;

export const SpanTextInstallments = styled.span`
  color: #000;
  font-size: 13px;
  font-weight: 600;
  margin-top: 1px;
  margin-left: 2px;
  @media print {
    font-size: 7pt;
  }
`;
